(function () {
    "use strict";
    angular
        .module("app")
        .factory("QuickSearchService", SearchService);

    function SearchService(WebApiService) {
        return {
            getQuickSearch: function (searchObj) {
                return WebApiService.postJson("/api/QuickSearch/QuickSearch", searchObj);
            }
        };
    }
})();
